import { render } from "./legup-tour.vue?vue&type=template&id=5b1b79bc"
import script from "./legup-tour.vue?vue&type=script&lang=js"
export * from "./legup-tour.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__